import axios from "axios";
import { api } from "./helper";
import router from "../routes/routes";
import store from "../store";
import { v4 as uuidv4 } from 'uuid';

// prepareDataRequest fonksiyonu bu yaklaşımda kullanılmayacaktır.
// Her zaman ana objeyi doğrudan hazırlayan prepareRequest kullanılacak.
export function prepareRequest(data) {
  return {
    ...data,
    RequestCorrelationId: uuidv4()
  };
}
function prepareDataRequest(data) {
  return {
    RequestCorrelationId: uuidv4(),
    Data: data
  };
}
const client = axios.create({
  baseURL: api,
  withCredentials: false,
});

client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

client.interceptors.response.use(
  (response) => {
    if (!response.data)
      if (response.data.indexOf("Unauthorized") > -1) {
        router.push("/logout");
      }
    return response;
  },
  (error) => {
    return { data: error.message };
  }
);

function CreateClaim(item) {
  return client.post("Claims/CreateClaim", prepareDataRequest(item));
}

function UpdateClaim(item) {
  return client.post("Claims/UpdateClaim", prepareDataRequest(item));
}

function DeleteClaim(id, uid) {
  var item = { Id: id, CommandUserId: uid };
  return client.post("Claims/DeleteClaim", prepareDataRequest(item) );
}

function GetClaims(id) {
  const data = { Id: id };
  return client.post("Claims/GetClaims", prepareRequest(data));
}

function GetClaim(id) {
  const data = { Id: id };
  return client.post("Claims/GetClaim", prepareRequest(data));
}

function CreateClaimDoc(item) {
  return client.post("ClaimDocs/CreateClaimDoc", prepareDataRequest(item));
}

function DeleteClaimDoc(id, uid) {
  var item = { Id: id, CommandUserId: uid, ClaimId: 0 };
  return client.post("ClaimDocs/DeleteClaimDoc",  prepareRequest(item) );
}

function GetClaimDocs(id) {
  const data = { ClaimId: id };
  return client.post("ClaimDocs/GetClaimDocs", prepareRequest(data));
}

function GetClaimDoc(id) {
  const data = { Id: id };
  return client.post("ClaimDocs/GetClaimDoc", prepareRequest(data));
}

function LastClaimStatus(id) {
  const data = { ClaimId:id };
  return client.post("Claims/LastClaimStatus", prepareRequest(data));
}

function SendToTechExpert(id, uid) {
  var item = { Id: id, CommandUserId: uid };
  return client.post("Claims/SendToTechExpert", prepareRequest(item));
}

function CreateTechExpert(item) {
  return client.post("ExpertData/CreateExpertData", prepareDataRequest(item));
}

function UpdateTechExpert(item) {
  return client.post("ExpertData/UpdateExpertData", prepareDataRequest(item));
}

function TechExpertUserUpdate(id, respUid, uid) {
  var item = { Id: id, RespUid: respUid, CommandUserId: uid };
  return client.post("ExpertData/TechExpertUserUpdate", prepareRequest(item));
}

function GetClaimTechExpert(id) {
  const data = { Id: id };
  return client.post("ExpertData/GetClaimTechExpert", prepareRequest(data));
}

function FinishTechExpert(id, uid) {
  var item = { Id: id, CommandUserId: uid };
  return client.post("ExpertData/FinishTechExpert", prepareRequest(item));
}

function SkipEvaluation(id, uid) {
  var item = { Id: id, CommandUserId: uid };
  return client.post("ExpertData/SkipEvaluation", prepareRequest(item));
}

function UploadServiceCenterAct(id, uid) {
  var item = { id: id, commandUserId: uid };
  return client.post("ExpertData/UploadServiceCenterAct", prepareDataRequest(item));
}

function RepairStageSparePartCopy(id, uid) {
  var item = { Id: id, CommandUserId: uid };
  return client.post("ExpertData/RepairStageSparePartCopy", prepareRequest(item));
}

function SendTechExpertApproval(id, uid) {
  var item = { Id: id, CommandUserId: uid };
  return client.post("ExpertData/SendTechExpertApproval", prepareRequest(item));
}

function TechExpertReject(item) {
  return client.post("ExpertData/TechExpertReject", prepareDataRequest(item));
}

function GetTechExpertReject(claimId, type) {
  const data = { claimId, type };
  return client.post("ExpertData/GetTechExpertReject", prepareRequest(data));
}

function PaymentReject(item) {
  return client.post("ClaimPayments/PaymentReject", prepareDataRequest(item));
}

function GetPaymentReject(claimId, type) {
  const data = { claimId, type };
  return client.post("ClaimPayments/GetPaymentReject", prepareRequest(data));
}

function TechExpertEvaluationClear(id, type, uid) {
  var item = { Id: id, Type: type, commandUserId: uid };
  return client.post("ExpertData/TechExpertEvaluationClear", prepareRequest(item));
}

function CreateAssessment(item) {
  return client.post("Assessments/CreateAssessment", prepareDataRequest(item));
}

function UpdateAssessment(item) {
  return client.post("Assessments/UpdateAssessment", prepareDataRequest(item));
}

function DeleteAssessment(id, uid) {
  var item = { id: id, commandUserId: uid };
  return client.post("Assessments/DeleteAssessment", { data: prepareDataRequest(item) });
}

function GetDamageAssessments(claimId) {
  const data = { claimId };
  return client.post("Assessments/GetDamageAssessments", prepareRequest(data));
}

function GetDamageAssessment(id) {
  const data = { id };
  return client.post("Assessments/GetDamageAssessment", prepareRequest(data));
}

function AssessmentMail(item) {
  return client.post("Notifications/AssessmentMail", item);
}

function GetApprasialForCallCenter(item) {
  if (item.searchText === "") {
    item.searchText = null;
  }
  return client.post("Assessments/GetApprasialForCallCenter", prepareRequest(item));
}

function GetClaimApprasial(claimId) {
  const data = { claimId };
  return client.post("Assessments/GetClaimApprasial", prepareRequest(data));
}

function CreateClaimAct(id, uid) {
  let item = { ClaimId: id, CommandUserId: uid };
  return client.post("ClaimActs/CreateClaimAct", prepareRequest(item));
}

function UpdateClaimAct(item) {
  return client.post("ClaimActs/UpdateClaimAct", prepareDataRequest(item));
}

function GetClaimAct(id) {
  const data = { Id : id };
  return client.post("ClaimActs/GetClaimAct", prepareRequest(data));
}

function SendToLegalExpert(id, uid) {
  var item = { id: id, commandUserId: uid };
  return client.post("Claims/SendToLegalExpert", prepareDataRequest(item));
}

function LegalExperStart(id, uid) {
  var item = { id: id, commandUserId: uid };
  return client.post("Claims/LegalExperStart", prepareRequest(item));
}

function SendToApprove(id, uid) {
  var item = { Id: id, CommandUserId: uid };
  return client.post("Claims/SendToApprove", prepareRequest(item));
}

function LegalExpertUserUpdate(id, respUid, uid) {
  var item = { Id: id, RespUid: respUid, CommandUserId: uid };
  return client.put("Claims/LegalExpertUserUpdate", prepareRequest(item));
}

function ChangeClaimVictim(id, uid) {
  var item = { Id: id, CommandUserId: uid };
  return client.post("Claims/ChangeClaimVictim", prepareRequest(item));
}

function ProportionalDivisionUpdate(id, uid) {
  var item = { Id: id, CommandUserId: uid };
  return client.post("Claims/ProportionalDivisionUpdate", prepareRequest(item));
}

function ChangeZbtIntegratedStatus(id, uid) {
  var item = { Id: id, CommandUserId: uid };
  return client.post("Claims/ChangeZbtIntegratedStatus", prepareRequest(item));
}

function FinishMedExpert(id, uid) {
  var item = { id: id, commandUserId: uid };
  return client.post("ExpertData/FinishMedExpert", prepareRequest(item));
}


function GetActApprovals(item) {

const data = {
  DtFrom: item.startDate,
  DtTo: item.endDate,
  ApproveType: item.approveType,
  User: item.commandUserId,
  RoleName: item.roleName,
  Page: item.page,
  PageSize: item.pageSize
};

  return client.post("ActApprovals/GetActApprovals", prepareRequest(data));
}
function GetActApproval(claimId) {
  const data = { claimId };
  return client.post("ActApprovals/GetActApproval", prepareRequest(data));
}

function UpdateActApproval(item) {
  return client.post("ActApprovals/ActApprovalUpdate", prepareDataRequest(item));
}

function LastActApprovalStatus(claimId) {
  const data = { ClaimId: claimId };
  return client.post("ActApprovals/LastActApprovalStatus", prepareRequest(data));
}

function CreateClaimPay(id, uid) {
  let item = { ClaimId: id, CommandUserId: uid };
  return client.post("ClaimPayments/CreateClaimPayment", prepareDataRequest(item));
}

function GetClaimPayment(id) {
  const data = { id };
  return client.post("ClaimPayments/GetClaimPayment", prepareRequest(data));
}

function ClaimPaymentFinish(id, uid) {
  var item = { Id: id, CommandUserId: uid };
  return client.post("ClaimPayments/ClaimPaymentFinish", prepareRequest(item));
}


function GetAllClaimsPayment(item) {
  if (item.searchText === "") {
    item.searchText = null;
  }
const data = {
  DtFrom: item.startDate,
  DtTo: item.endDate,
  StatusType: item.statusType,
  SearchType: item.searchType,
  SearchText: item.searchText,
  PageNumber: item.pageNumber,
  PageSize: item.pageSize,
    DataExport: item.dataExport,
  Subrogation: item.subrogation,
    Zbt: item.zbt,
     User: item.commandUserId
};

  return client.post("ClaimPayments/GetAllClaimsPayment", prepareRequest(data));
}


function GetClaimsPayment(item) {
  if (item.searchText === "") {
    item.searchText = null;
  }
const data = {
  DtFrom: item.startDate,
  DtTo: item.endDate,
  StatusType: item.statusType,
  SearchType: item.searchType,
  SearchText: item.searchText,
  PageNumber: item.pageNumber,
  PageSize: item.pageSize,
    DataExport: item.dataExport,
  Subrogation: item.subrogation,
    Zbt: item.zbt,
     User: item.commandUserId
};

  return client.post("ClaimPayments/GetClaimsPayment", prepareRequest(data));
}


// Client service END
export {
  CreateClaim,
  UpdateClaim,
  DeleteClaim,
  GetClaims,
  GetClaim,
  CreateClaimDoc,
  DeleteClaimDoc,
  GetClaimDocs,
  GetClaimDoc,
  SendToTechExpert,
  CreateTechExpert,
  TechExpertUserUpdate,
  GetClaimTechExpert,
  UpdateTechExpert,
  FinishTechExpert,
  CreateClaimAct,
  UpdateClaimAct,
  GetClaimAct,
  SendToLegalExpert,
  LegalExperStart,
  SendToApprove,
  LastClaimStatus,
  LegalExpertUserUpdate,
  GetActApprovals,
  UpdateActApproval,
  GetActApproval,
  SkipEvaluation,
  FinishMedExpert,
  CreateAssessment,
  UpdateAssessment,
  DeleteAssessment,
  GetDamageAssessment,
  GetDamageAssessments,
  GetApprasialForCallCenter,
  GetClaimApprasial,
  UploadServiceCenterAct,
  RepairStageSparePartCopy,
  LastActApprovalStatus,
  CreateClaimPay,
  GetClaimPayment,
  ClaimPaymentFinish,
  AssessmentMail,
  GetAllClaimsPayment,
  GetClaimsPayment,
  ChangeClaimVictim,
  SendTechExpertApproval,
  TechExpertReject,
  GetTechExpertReject,
  PaymentReject,
  GetPaymentReject,
  TechExpertEvaluationClear,
  ProportionalDivisionUpdate,
  ChangeZbtIntegratedStatus,
prepareDataRequest
};